import { useEffect, useState } from "react";
import SectionLabel from "@/components/SectionLabel";
import { api } from "@/lib/api";

const pinnedItems = [
  {
    id: "pinned-new-gkk-juan-maria-vianney",
    badge: "New GKK",
    title: "A New GKK is Established",
    body: "With grateful hearts, the parish welcomes the newly established GKK San Juan Maria Vianney, Dwelling Homes, Brgy. Mabuhay, General Santos City — bringing our parish to 56 Gagmay'ng Kristohanong Katilingban serving the People of God.",
  },
];

const defaultItems = [
  {
    id: "d1",
    badge: "Formation",
    title: "GKK Bible Service",
    body: "GKKs are encouraged to continue gathering around the Word of God through regular Bible services and community prayer.",
  },
  {
    id: "d2",
    badge: "Mission",
    title: "Pastoral Visitation",
    body: "The parish continues its pastoral journey of listening, accompaniment, and strengthening of communities.",
  },
  {
    id: "d3",
    badge: "Service",
    title: "Relief & Social Action",
    body: "The parish remains committed to families and communities affected by calamities, poverty, and urgent needs.",
  },
];

export default function Announcements() {
  const [items, setItems] = useState(defaultItems);

  useEffect(() => {
    api
      .get("/announcements")
      .then((res) => {
        if (res.data && res.data.length > 0) setItems(res.data);
      })
      .catch(() => {});
  }, []);

  // Always show the pinned new-GKK announcement first, deduped by id.
  const displayed = [
    ...pinnedItems,
    ...items.filter((x) => !pinnedItems.some((p) => p.id === x.id)),
  ];

  return (
    <section id="announcements" className="py-24 md:py-36 bg-parchment-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel
          kicker="Parish Updates"
          title="Announcements"
          intro="Formation schedules, special Masses, pastoral programs, and community announcements."
        />

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {displayed.slice(0, 6).map((a) => (
            <article
              key={a.id}
              className="border-l-2 border-terracotta bg-parchment-200/40 p-8 hover:bg-parchment-200 transition-colors"
            >
              <div className="text-[10px] uppercase tracking-[0.28em] text-sage-dark font-sans mb-4">
                {a.badge}
              </div>
              <h3 className="font-serif text-2xl text-cocoa-900 mb-3 leading-tight">
                {a.title}
              </h3>
              <p className="font-sans text-cocoa-800 leading-relaxed font-light text-[15px]">
                {a.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
